module.exports = __webpack_public_path__ + "img/2.e3ae3c45.png";